import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useMuiPickersLocale } from '../../../../hooks';
import DashboardWidgetCard from '../../DashboardWidgetCard';
import { DailySalesDataGrid } from './DailySalesDataGrid';

const lastMonthLastDay = new Date();
lastMonthLastDay.setDate(0);

const GridContainer = styled(Grid)`
  display: flex;
  flex-direction: row;
  max-height: 90%;
  width: 100%;
  overflow: auto;
`;

const DailySalesIncorporation = () => {
  const { t } = useTranslation();
  const locale = useMuiPickersLocale();

  return (
    <DashboardWidgetCard
      title={t('dashboard.daily-sales.title', { date: format(new Date(), 'P', { locale }) })}
    >
      <GridContainer sx={{ flexGrow: 1, overflow: 'auto' }}>
        <DailySalesDataGrid />
      </GridContainer>
    </DashboardWidgetCard>
  );
};

export default DailySalesIncorporation;
